import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdBanner from '../components/AdBanner';
import './Home.css';

const Home = () => {
  const { isPremium } = useAuth();

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Professional Bills of Sale & Invoices
              <span className="hero-highlight"> in Minutes</span>
            </h1>
            <p className="hero-subtitle">
              Perfect for Craigslist, Facebook Marketplace, OfferUp, and other online transactions. 
              Create clear documentation for every sale.
            </p>
            <div className="hero-actions">
              <Link to="/bill-of-sale" className="btn btn-primary btn-lg">
                Create Bill of Sale
              </Link>
              <Link to="/invoice" className="btn btn-secondary btn-lg">
                Create Invoice
              </Link>
            </div>
            <p className="hero-note">
              ✓ Free to use &nbsp;&nbsp; ✓ No account required &nbsp;&nbsp; ✓ Instant PDF download
            </p>
          </div>
        </div>
      </section>

      {/* Ad Banner */}
      <div className="container">
        <AdBanner slot="home-top" />
      </div>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">Why Use PrivateSold?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📝</div>
              <h3>Easy to Use</h3>
              <p>Simple, intuitive forms that guide you through creating professional documents in minutes.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Instant Download</h3>
              <p>Generate and download your PDF documents immediately. No waiting, no hassle.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Professional & Complete</h3>
              <p>Our templates cover all the important details to keep both buyers and sellers protected.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>Free Forever</h3>
              <p>Generate unlimited documents for free. Premium storage available for those who need it.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <div className="container">
          <h2 className="section-title">How It Works</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Fill in Details</h3>
              <p>Enter buyer, seller, and item information in our easy-to-use form.</p>
            </div>
            <div className="step-arrow">→</div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Review Document</h3>
              <p>Preview your document to ensure all information is correct.</p>
            </div>
            <div className="step-arrow">→</div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Download PDF</h3>
              <p>Get your professional document instantly as a downloadable PDF.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Ad Banner */}
      <div className="container">
        <AdBanner slot="home-middle" />
      </div>

      {/* Use Cases */}
      <section className="use-cases">
        <div className="container">
          <h2 className="section-title">Perfect For</h2>
          <div className="use-cases-grid">
            <div className="use-case">
              <h4>🚗 Vehicle Sales</h4>
              <p>Cars, motorcycles, boats, and more</p>
            </div>
            <div className="use-case">
              <h4>📱 Electronics</h4>
              <p>Phones, computers, gaming consoles</p>
            </div>
            <div className="use-case">
              <h4>🛋️ Furniture</h4>
              <p>Home goods and appliances</p>
            </div>
            <div className="use-case">
              <h4>🎸 Collectibles</h4>
              <p>Antiques, instruments, art</p>
            </div>
            <div className="use-case">
              <h4>🏠 Marketplace Sales</h4>
              <p>Facebook, Craigslist, OfferUp</p>
            </div>
            <div className="use-case">
              <h4>💼 Business Items</h4>
              <p>Equipment, inventory, supplies</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Get Started?</h2>
            <p>Create your first bill of sale or invoice in under 2 minutes.</p>
            <div className="cta-actions">
              <Link to="/bill-of-sale" className="btn btn-primary btn-lg">
                Create Bill of Sale
              </Link>
              <Link to="/invoice" className="btn btn-secondary btn-lg">
                Create Invoice
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Premium Promo - Only show to non-premium users */}
      {!isPremium() && (
        <section className="premium-promo">
          <div className="container">
            <div className="premium-card">
              <div className="premium-content">
                <span className="premium-badge">Premium</span>
                <h3>Save & Access Your Documents Anytime</h3>
                <p>
                  Upgrade to Premium to store unlimited documents, access your history, 
                  and enjoy an ad-free experience.
                </p>
                <ul className="premium-features">
                  <li>✓ Unlimited document storage</li>
                  <li>✓ Access document history</li>
                  <li>✓ Ad-free experience</li>
                  <li>✓ Priority support</li>
                </ul>
                <Link to="/subscription" className="btn btn-success btn-lg">
                  Upgrade for $4.99/month
                </Link>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default Home;
